import { Grid, Row } from 'antd'
import KCol from 'app/components//UI-Elements/Layout/KCol'
import { RecordType } from 'app/constants/GlobalTypes'
import useTranslation from 'app/lib/hooks/useTranslation'
import { FC } from 'react'

import { CollectionProps } from '../convention'
import { filterByStatus } from './helpers'
import InteractionButton from './MachineInteractionButton'
import Table, { ILineItemRow } from './Table'
import Filters from './Table/Filters'
import useStatusFilter from './Table/hooks/useStatusFilter'

type Props = {
  filter?: boolean
}

const MachineList: FC<CollectionProps<ILineItem, Props>> = ({ collection, props: { filter } }) => {
  const { tRecordType } = useTranslation({
    recordType: RecordType.line_item,
    scope: 'title'
  })
  const preparedCollection = usePreparedCollection(collection, filter)

  const interactionDisabled = !preparedCollection.find(
    ({ checkupEnabled, filterStatus }) => checkupEnabled && filterStatus === 'current'
  )

  return (
    <KCol card span={24} title={tRecordType({ id: 'list_title' })}>
      <Row gutter={[12, 12]} justify="end" style={{ marginTop: '-24px' }}>
        <KCol span={24}>
          <Table
            filters={<Filters filter={filter} />}
            dataSource={preparedCollection}
            expandable={{ defaultExpandAllRows: true }}
          />
        </KCol>
        <KCol>
          <InteractionButton disabled={interactionDisabled} />
        </KCol>
      </Row>
    </KCol>
  )
}

export default MachineList

const usePreparedCollection = (collection: ILineItem[], filter: boolean) => {
  const { statusFilter } = useStatusFilter()
  const { xs: disableExpand } = Grid.useBreakpoint()

  function prepareCollection(collection: ILineItem[], disableExpand: boolean) {
    if (!collection.length) return []
    if (disableExpand) return collection

    const prepareNestedRows = (lineItem: ILineItem): ILineItemRow => ({
      ...lineItem,
      children: lineItem.subItems?.length ? lineItem.subItems?.map(prepareNestedRows) : undefined
    })

    return collection.map(prepareNestedRows)
  }

  const filterCollection = statusFilter && filter
  const filteredCollection = filterByStatus(collection, statusFilter, filterCollection)
  return prepareCollection(filteredCollection, disableExpand)
}
